import React from 'react';
import { Link } from 'react-router-dom';
import { Radio } from 'lucide-react';

// "More from the community" related articles grid.
const RelatedArticles = ({ articles }) => (
  <section className="px-6 lg:px-10 py-16">
    <div className="max-w-[1100px] mx-auto">
      <h2 className="font-serif-dctv text-2xl font-bold text-white mb-8">More from the community</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {articles.map((n) => (
          <Link to={`/news/${n.id}`} key={n.id} className="dctv-card rounded-2xl overflow-hidden group">
            <div className="h-40 overflow-hidden bg-[#0a0e16] flex items-center justify-center">
              {n.image ? (
                <img src={n.image} alt={n.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              ) : (
                <Radio className="w-9 h-9 text-[#e8743b]" />
              )}
            </div>
            <div className="p-5">
              <span className="dctv-eyebrow text-[#e8743b] text-[10px]">{n.theme || n.category}</span>
              <h3 className="font-serif-dctv text-[17px] font-semibold text-white mt-2 leading-snug group-hover:text-[#f4965a] transition-colors">{n.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default RelatedArticles;
